import { createSlice } from '@reduxjs/toolkit';
import { updateLocalStorageToken, logOut } from "../../../../../../containers/resources/utils";
import axios from 'axios';

export const reservationDueDateSlice = createSlice({
  name: 'reservationDueDate',
  initialState: {
    items: [],
    processing: false,
    fetching: false,
    message: "",
    error: "",
  },
  reducers: {
    initialStateReservationDueDate(state, action) {
      return {
        items: [],
        processing: false,
        fetching: false,
        message: "",
        error: "",
      }
    },
    requesReservationDueDate(state, action) {
      return {
        items: [],
        processing: false,
        fetching: true,
        message: "",
        error: "",
      }
    },
    fetchReservationDueDateSuccess(state, action) {
      return {
        items: action.payload,
        processing: false,
        fetching: false,
        message: "",
        error: "",
      }
    },
    fetchReservationDueDateError(state, action) {
      return {
        items: [],
        processing: false,
        fetching: false,
        message: "",
        error: action.payload.message,
      }
    }
  }
})

export const fetchReservationDueDateThunk = (cruiseYacht, startDate, endDate) => dispatch => {
  dispatch(requesReservationDueDate());
  var url = "reservationDueDate";
  url = url + `?cruiseYacht=${cruiseYacht}&&startDate=${startDate}&&endDate=${endDate}`;
  axios.get(`/${url}`)
    .then(json => {
      if (json.data.code === 200) {
        dispatch(fetchReservationDueDateSuccess(json.data.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(fetchReservationDueDateThunk(cruiseYacht, startDate, endDate));
      } else if (json.data.code === 498) {
        logOut();
      } else { 
        dispatch(fetchReservationDueDateError(json.data.data));
      }
    })
};

export const {
  initialStateReservationDueDate,
  requesReservationDueDate,
  fetchReservationDueDateSuccess,
  fetchReservationDueDateError,
} = reservationDueDateSlice.actions;

export default reservationDueDateSlice.reducer;